import React, { ReactNode, useState } from 'react';

interface AdminShellProps {
  children: ReactNode;
  header: ReactNode;
  sidebar: (closeSidebar: () => void) => ReactNode;
  mobileHeaderTitle?: ReactNode;
}

const AdminShell: React.FC<AdminShellProps> = ({ children, header, sidebar, mobileHeaderTitle }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="relative font-sans text-stone-800 flex min-h-screen overflow-hidden bg-gradient-to-br from-stone-50 via-stone-100/80 to-teal-50/40">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-24 top-0 h-72 w-72 rounded-full bg-teal-200/20 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute bottom-0 left-1/3 h-64 w-64 rounded-full bg-amber-100/30 blur-3xl"
      />
      {sidebarOpen && (
        <button
          type="button"
          className="fixed inset-0 z-40 bg-black/40 md:hidden"
          aria-label="メニューを閉じる"
          onClick={closeSidebar}
        />
      )}

      <div
        className={[
          'fixed inset-y-0 left-0 z-50 w-64 max-w-[85vw] transform transition-transform duration-200 ease-out md:static md:translate-x-0 md:shrink-0',
          sidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0',
        ].join(' ')}
      >
        {sidebar(closeSidebar)}
      </div>

      <main className="flex min-w-0 flex-1 flex-col">
        <div className="sticky top-0 z-30 flex items-center gap-3 border-b border-teal-100/80 bg-white/90 px-4 py-3 backdrop-blur md:hidden">
          <button
            type="button"
            className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-teal-100 bg-white text-teal-700 shadow-sm"
            aria-label="メニューを開く"
            aria-expanded={sidebarOpen}
            onClick={() => setSidebarOpen(true)}
          >
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <span className="min-w-0 flex-1 truncate text-sm font-medium text-stone-700">
            {mobileHeaderTitle}
          </span>
        </div>

        <div className="flex-1 p-4 sm:p-6 md:p-8">
          {header}
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminShell;
